module.exports = __webpack_public_path__ + "img/campusbook_go.63fa8afa.png";